import React from "react";
import Select, { components } from "react-select";


export default function DropdownField(props) {
    const { className, label, labelClass, required, name, onChangeHandler, placeholder, errors, options, defaultValue, isMulti, form, customeStyle, selectClass, classForClearIcon, isLoading} = props

    const customStyles = {
        menuPortal: base => ({
            ...base,
            position: 'static',
        }),
        placeholder: base =>({
            ...base,
            fontSize : '15F',
            padding : 0,
            paddingTop: 0,
            paddingBottom: 0,
            color: "#999999"
        }),
        multiValueLabel: base =>({
            ...base,
            fontSize : '1rem'
        }),
        singleValue: base =>({
            ...base,
            fontSize : '1rem',
            padding : 0,
        }),
        container : base => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
        }),
        menu: base => ({
            ...base,
            marginTop: 0,
        }),
        control: (provided, state) => ({
            ...provided,
            minHeight: '2rem',
            border : state.isFocused ? 'none' : 'none',
            outline : state.isFocused ? 'none' : 'none',
            borderRadius : 0
        }),
      }
      
    const DropdownIndicator = props => {
        return (
          <components.DropdownIndicator {...props}>
            <span className="material-icons">expand_more</span>
          </components.DropdownIndicator>
        );
    };

    const ClearIndicator  = props => {
        return (
          <components.DropdownIndicator {...props}>
            <span className="material-icons text-xl font-bold">clear</span>
          </components.DropdownIndicator>
        );
    };
      

    return (
        <>
            <div className={customeStyle ? customeStyle : ` px-1 py-1 relative  ${className}`} id='dropdown'>
                <label className='relative block border-b-2 border-scogoddd '>
                    <span className={`text-15F text-blurgray ${labelClass}`}>{label} {required && <span >*</span>} </span>
                    <Select
                         components={{ DropdownIndicator, ClearIndicator  }}
                         onChange={(value) => { onChangeHandler({ name: name, value: value }) }}
                         placeholder={placeholder}
                         name={name}
                         defaultValue={options?.find?.(option => option?.value === defaultValue)}
                         options={options && options}
                         isSearchable
                         menuPortalTarget={document.getElementById('dropdown')}
                         styles={customStyles}
                         menuShouldBlockScroll={false}
                         className={'select-text w-full text-font12 ' + selectClass }
                         classNamePrefix='select'
                         menuPlacement={'auto'}
                         value={form[name]}
                         isClearable
                    />
                </label>
                {errors[name] && <span className="text-scogoRed text-font10 font-normal">{errors[name]}</span>}
            </div>
        </>
    )
}
